import { atom } from "jotai";

import { I18nKeyType } from "@libs/i18n";
import { UserRoleType, UserType } from "@/domain/auth";

export const userRoleAtom = atom<UserRoleType | null>(null);
export const userCurrentCampusId = atom<string | null>(null);

export const discardChangesAtom = atom<{
  entityI18nKeyType: I18nKeyType;
  action: "CREATE" | "UPDATE";
} | null>(null);

export const emailChangeDialogOptionsAtom = atom<{
  userType: UserType;
  newEmailAddress: string;
  onConfirm: () => void;
} | null>(null);
